import React from 'react';
import PageFrameFloor from '../components/commons/pageFrameFloor';
import Floor from '../pages/floor';
import Home from '../pages/home';
import { InteractiveMapPage } from '../pages/interactiveMap';

const floorRouteProvider = (floorConfig, basename) => {
  const floorConfigArray = Object.keys(floorConfig).map((locationKey) => {
    return {
      path: floorConfig[locationKey].sectionPath,
      exact: false,
      Component: (path, routes) => (
        <PageFrameFloor>
          <Floor
            location={floorConfig[locationKey]}
            path={path}
            routes={routes}
            basename={basename}
          />
        </PageFrameFloor>
      ),
      children: [...floorConfig[locationKey].paths],
    };
  });
  return floorConfigArray;
};

export const appRouter = (floorStatics, basename) => {
  return [
    {
      path: '/',
      exact: true,
      Component: () => <Home />,
      children: [],
    },
    {
      path: '/interactive_map',
      exact: true,
      Component: () => <InteractiveMapPage />,
      children: [],
    },
    ...floorRouteProvider(floorStatics, basename),
  ];
};
